import { Box } from "@mui/material";
import MessagesList from "./MessagesList";
import MessageView from "./MessageView";
import ConversationThread from "./ConversationThread";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { markMessageAsRead } from "../../redux/actions/messages";
import useMessagesAPIClient from "../../api/messages/hooks/useMessagesAPIClient";

const MessagesDesktop = () => {
  const [activeMessageId, setActiveMessageId] = useState(null);
  const [showConversation, setShowConversation] = useState(false);
  const messages = useSelector((state) => state.messages);
  const { markMessageAsRead: markMessageAsReadAPICall } =
    useMessagesAPIClient();
  const dispatch = useDispatch();

  const onMessageClick = async (messageId) => {
    setActiveMessageId(messageId);
    setShowConversation(false);

    // If message is already read do not dispatch or call API
    const message = messages.find((msg) => msg.messageId === messageId);
    if (message.read) {
      return;
    }
    dispatch(markMessageAsRead(messageId));
    await markMessageAsReadAPICall(messageId);
  };

  const onConversationClick = () => {
    setShowConversation(true);
    setActiveMessageId(null);
  };

  return (
    <Box className="messages--desktop">
      <MessagesList
        onMessageClick={onMessageClick}
        activeMessageId={activeMessageId}
        onConversationClick={onConversationClick}
        conversationActive={showConversation}
      />
      {showConversation ? (
        <ConversationThread />
      ) : (
        <MessageView activeMessageId={activeMessageId} />
      )}
    </Box>
  );
};

export default MessagesDesktop;
